package pl.decks.personal.components.widgets.ranks

typealias SVGLine = List<SVGPoint>

fun SVGLine.line(): String = this.joinToString(" ") { it.coordinates() }
